import { createContext, useState } from "react";
import { PAGES } from "./constants";

export const PageContext = createContext();

export function PageContextProvider({ children }) {
  const [page, setPage] = useState(PAGES.HOME);

  const val = {
    page,
    setPage,
  };

  return <PageContext.Provider value={val}>{children}</PageContext.Provider>;
}
